exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2094230074/src/src/app/generic-ui-components/generic-fetching-records/generic-fetching-records.component.scss
// module id = ../../../../../src/app/generic-ui-components/generic-fetching-records/generic-fetching-records.component.scss
// module chunks = main